module.exports = __webpack_public_path__ + "media/images/soar/site/highlight_01-11ea7e0889b8bb9170167476c6e0ca9d.svg";